<template lang="pug">
    collapsed-credential-sections(:sections="[lvl2]")
</template>
<script>
import credential from '../../../constants/tooltips/credentials'
import CollapsedCredentialSections from './CollapsedCredentialSections'

export default {
  components: {
    CollapsedCredentialSections,
  },
  data () {
    return {
      lvl2: {
        title: 'Verifiable LEIs',
        property: 'showLevelTwoChildren',
        tableLayout: 'credentials',
        tip: credential.leCredential,
        data: [],
      },
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/record-details/credentials/CredentialRecordInfo.vue